import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconAirplay",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, i, p, f, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--airplay"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Airplay",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...r[0] || (r[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h.5a.5.5 0 0 1 0 1H2A1.5 1.5 0 0 1 .5 7.5v-5A1.5 1.5 0 0 1 2 1h8a1.5 1.5 0 0 1 1.5 1.5v5A1.5 1.5 0 0 1 10 9h-.5a.5.5 0 0 1 0-1h.5a.5.5 0 0 0 .5-.5v-5A.5.5 0 0 0 10 2H2Z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 7a.5.5 0 0 1 .384.18l2.5 3A.5.5 0 0 1 8.5 11h-5a.5.5 0 0 1-.384-.82l2.5-3A.5.5 0 0 1 6 7Zm-1.432 3h2.864L6 8.281 4.568 10Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const A = /* @__PURE__ */ s(c, [["render", m]]);
export {
  A as default
};
//# sourceMappingURL=airplay.js.map
